import { makeStyles } from '@material-ui/core';
import docIcon from './doc-logo-icon-white.svg';

// The shield part of DOC's logo, for the collapsed sidebar. Same SVG as the full
// logo with the viewBox cropped to the shield.
const useStyles = makeStyles({
  img: { height: 32, width: 'auto' },
});

export const LogoIcon = () => {
  const classes = useStyles();
  return <img className={classes.img} src={docIcon} alt="DOC" />;
};
